import classNames from 'classnames'
import {
  Icon,
  IconName
} from 'src/pages/orders/components/RatingTab/components'
import './TabButton.scss'
import { ReactComponent as WineGlassIcon } from 'src/assets/svg/wine-glass.svg'

type TabButtonProps = {
  onClick?: Function
  label?: string
  className?: string
  isSelected: boolean
  withIcon?: boolean
  withWineIcon?: boolean
  isIconFilled?: boolean
}

const TabButton = ({
  label,
  onClick,
  className = '',
  isSelected,
  withIcon = false,
  withWineIcon = false,
  isIconFilled = false
}: TabButtonProps) => {
  return (
    <button
      className={classNames('tab', className, {
        selected: isSelected,
        'with-icon': withIcon || withWineIcon,
        clickable: !!onClick
      })}
      onClick={() => onClick && onClick()}>
      {withWineIcon && <WineGlassIcon className="tab__wine-icon" />}
      {!!label && <span className="tab__label">{label}</span>}
      {withIcon && (
        <Icon
          name={isIconFilled ? IconName.FULL_STAR : IconName.EMPTY_STAR}
          className={classNames('tab__icon', { filled: isIconFilled })}
        />
      )}
    </button>
  )
}

export default TabButton
